var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBarcodeScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1755_42015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1755_42015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 24.5V18.6667H3.50033V22.1667H7.00033V24.5H1.16699ZM21.0003 24.5V22.1667H24.5003V18.6667H26.8337V24.5H21.0003ZM4.66699 21V7H7.00033V21H4.66699ZM8.16699 21V7H9.33366V21H8.16699ZM11.667 21V7H14.0003V21H11.667ZM15.167 21V7H18.667V21H15.167ZM19.8337 21V7H21.0003V21H19.8337ZM22.167 21V7H23.3337V21H22.167ZM1.16699 9.33333V3.5H7.00033V5.83333H3.50033V9.33333H1.16699ZM24.5003 9.33333V5.83333H21.0003V3.5H26.8337V9.33333H24.5003Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarcodeScanner);
export default __webpack_public_path__ + "static/media/icon_barcode_scanner.c3924457d17916e04fdf0d8baed38ebe.svg";
export { ForwardRef as ReactComponent };